










































































import Vue from 'vue';
import { Terminal } from '@payment-terminals/interfaces/terminal';
import { Component, Prop } from 'vue-property-decorator';
import CashdroService from '@pos/services/cashdro-service';
import { CashdroAlert, CashdroLevels } from '@pos/interfaces/cashdro-specific-responses-interface';
import CashdroLevelsTable from '@payment-terminals/components/tables/cashdro-levels-table/cashdro-levels-table.vue';
import CashdroErrorHelper from '@pos/helpers/cashdro-error-helper';

@Component({
  name: 'bpc-check-cashdro-status-modal',
  components: {
    'bpc-cashdro-levels-table': CashdroLevelsTable,
  },
})
export default class InvoiceGenerationModal extends Vue {
  // PROPS
  @Prop({ type: String, default: 'check-cashdro-status-modal' }) readonly modalId: string;

  // DATA
  requestSent: boolean = false;
  isProcessing: boolean = false;
  isTerminalOk: boolean = false;
  error: boolean = false;
  errorMessage: string = '';
  readonly errorMessageText: string = 'global.generic.error_form_action';
  readonly succesStatusMessageText: string = 'payment_terminals.cashdro.success_status_message';
  terminalLevels: CashdroLevels[] = [];
  isGettingLevels: boolean = false;

  public cashdro: Terminal = {
    device_id: null,
    name: null,
    status: null,
    type: 'cashdro',
  };
  // COMPUTED
  get modalTitle() {
    return (
      this.$t('global.modals.check-cashdro-status.title') +
      ' - [' +
      this.cashdro?.device_id +
      '] ' +
      this.cashdro?.name
    );
  }

  get modalBody() {
    return this.$t('global.modals.invoice_generation.body');
  }

  get tenantId(): number {
    return this.$store.getters['tenant/selectedTenantId'];
  }
  get existLevelWithAlerts() {
    if (this.terminalLevels.length) {
      return this.terminalLevels.find(
        level => level.State !== '-1' && parseInt(level.Destination) !== 0,
      );
    }
    return false;
  }
  get levelAlertsMsg(): string {
    const errorHelper = new CashdroErrorHelper();
    return errorHelper.cashdroUnitTermilansWithAlersError().msg;
  }

  // LIFECYCLE

  // METHODS
  initVars(cashdro) {
    this.requestSent = false;
    this.isProcessing = false;
    this.error = false;
    this.errorMessage = '';
    this.isTerminalOk = false;
    this.cashdro = cashdro;
  }
  closeModal() {
    this.$bvModal.hide(this.modalId);
  }

  openModal(cashdro: Terminal) {
    this.$bvModal.show(this.modalId);
    this.initVars(cashdro);
    this.getCashdroStatus();
  }

  async getCashdroStatus() {
    this.requestSent = true;
    this.isProcessing = true;
    this.error = false;
    this.errorMessage = '';
    this.isTerminalOk = false;

    const cashdroService = new CashdroService();
    const terminal: Terminal = this.cashdro;

    const terminalStatusResponse = await cashdroService.getTerminalStatus(terminal);
    const result = terminalStatusResponse.getResult();

    if (terminalStatusResponse.ok()) {
      this.isProcessing = false;
      this.isTerminalOk = true;
      this.isGettingLevels = true;
      const terminalLevelsResponse = await cashdroService.getTerminalLevels(terminal);

      if (terminalLevelsResponse.ok()) {
        const levelsResult = terminalLevelsResponse.getResult();
        this.terminalLevels = levelsResult.content.operation.pieces;
        this.isProcessing = false;
        this.isTerminalOk = true;
        this.isGettingLevels = false;
      } else {
        const levelsResult = terminalLevelsResponse.getResult();
        this.terminalLevels = levelsResult.content.operation.pieces;
        this.isProcessing = false;
        this.isTerminalOk = false;
        this.error = true;
        this.errorMessage = levelsResult.error.msg;
        this.isGettingLevels = false;
      }
    } else {
      console.log('Error');
      console.log(result.error);
      this.isProcessing = false;
      this.isTerminalOk = false;
      this.error = true;
      this.errorMessage = result.error.msg;
    }
  }

  // WATCHERS
}
